module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/1@2x_e77d22b178aa2d9cfa41eb12126fab74.png";